import React from 'react';

const AddGoalButton = (props) => {
  return (
    <button className="goal-button" onClick={props.handleOpen}>
      Add Goal
    </button>
  )
};
export default AddGoalButton;